import React, { useReducer } from 'react';

const updateStateObject = (oldObject, newValues={}, sync=false) => {
	let newStateObject = {...oldObject, ...newValues};
	return sync ? syncStateObject(newStateObject) : newStateObject
}

//Will apply after effects here i.e any day/night logic
const syncStateObject = (state) => {

	//Check if any items on last day?
	let lastDay = state.days;

	//Hashmap for active days
	let activeDays = {};
	for(let i=1; i <=lastDay; i++){
		activeDays[i] = !!state.activities.find(act => act.day == i);
	}

	//Mark any days occupied by hotel as active
	if(state.hotel){
		for(let night=1; night <= state.hotel.nights; night++){
			let day = -1 + (state.hotel.day) + night;
			activeDays[day] = true;
		}
	}

	//Mark any days occupied by hotel as active
	if(state.superPackage){
		for(let night=1; night <= state.superPackage.nights; night++){
			let day = -1 + (state.superPackage.day) + night;
			activeDays[day] = true;
		}
	}

	//Work backwards from last day, stripping out empty days
	while( lastDay > 1 && activeDays[lastDay] == false ){
		lastDay--;
	}

	if(state.days!==lastDay){
		state.days = lastDay;
	}
	return state;
}

const reducer = (state, action) => {

	let activities,
		index,
		changes = {};

	switch(action.type){
		case "ADD_DAY":
			return updateStateObject(state, {days: state.days+1});
		case "REMOVE_DAY":
			//Do we need to change our hotel?
			let changes = { days: state.days-1 };
			if(state.hotel && ((state.hotel.day + state.hotel.nights)-1) > state.days-1){
				changes.hotel = {...state.hotel, nights: state.hotel.nights-1}
			}

			//remove any super packages
			if( state.superPackage ){
				changes.superPackage = false
			}

			
			//remove any activities
			changes.activities = state.activities.filter( activity => activity.day !== state.days);
			return updateStateObject(state, changes);
		case 'ADD_ACTIVITY':
			activities = [...state.activities];
			index = activities.findIndex( (event) => event.id == action.event.id);
			if( index >-1 ){
				activities.splice(index, 1);
			} else {
				activities.push({
					id: parseInt(action.event.id),
					name: action.event.name,
					preferredTimeSlot: parseInt(action.event.preferredTimeSlot),//morning/afternoon
					period: parseInt(action.event.period), //is this evening/afernoon event?
					day: parseInt(action.event.day),
					pax: parseInt(state.pax),
					image: action.event.image
				})
			}
			activities.sort((a,b)=>{
				let comparison = 0;
				if( a.day==b.day ){
					return a.preferredTimeSlot-b.preferredTimeSlot;
				} else {
					return a.day > b.day ? 1 : -1;
				}
			})

			return updateStateObject(state, {activities: activities});

		case 'EDIT_ACTIVITY':
			if( state.activities.length > 0 ){
				activities = state.activities;
				index = activities.findIndex( (event) => event.id == action.id);
				if( index >-1 ){
					activities[index] = {...activities[index], pax: action.pax, preferredTimeSlot: action.preferredTimeSlot, day: action.day};
					changes = {activities: activities}
				}
			}
			return updateStateObject(state, changes, true);

		case 'REMOVE_ACTIVITY':
			activities = [...state.activities];
			index = activities.findIndex( (event) => event.id == action.event.id);
			if( index >-1 ){
				activities.splice(index, 1);
			}
			return updateStateObject(state, {activities: activities}, true);

		case 'ADD_HOTEL':
			if( state.hotel && state.hotel.id == action.hotel.id && state.hotel.type == action.type ){
				return updateStateObject(state, {hotel: false});
			} else {

				let newDays = state.days < ((parseInt(action.hotel.day) + parseInt(action.hotel.nights)-1)) ? (parseInt(action.hotel.day) + parseInt(action.hotel.nights)-1) : state.days;

				let newHotel = {
					id: parseInt(action.hotel.id),
					type: action.hotel.type,
					name: action.hotel.name,
					day: parseInt(action.hotel.day),
					pax: action.hotel.pax && action.hotel.pax > 0 ? parseInt(action.hotel.pax) : parseInt(state.pax),
					image: action.hotel.image,
					nights: parseInt(action.hotel.nights)
				}
				return updateStateObject(state, {hotel: newHotel, days: newDays, nights: parseInt(action.hotel.nights) });
			}
		case 'EDIT_HOTEL':
			if( state.hotel ){
				let hotel = state.hotel;
				hotel.nights = action.nights;
				hotel.pax = action.pax;

				changes = {
					hotel: hotel,
					days: state.days < ((parseInt(hotel.day) + parseInt(hotel.nights)-1)) ? (parseInt(hotel.day) + parseInt(hotel.nights)-1) : state.days
				}
			}
			return updateStateObject(state, changes, true);
		case 'REMOVE_HOTEL':
			return updateStateObject(state, {hotel:false, nights: 0});

		case 'ADD_SUPER_PACKAGE':
			if( state.superPackage && state.superPackage.id == action.superPackage.id ){
				return updateStateObject(state, {superPackage: false});
			} else {

				let newDays = state.days < ((parseInt(action.superPackage.day) + parseInt(action.superPackage.nights)-1)) ? (parseInt(action.superPackage.day) + parseInt(action.superPackage.nights)-1) : state.days;

				let newSuperPackage = {
					id: parseInt(action.superPackage.id),
					name: action.superPackage.name,
					day: parseInt(action.superPackage.day),
					pax: action.superPackage.pax && action.superPackage.pax > 0 ? parseInt(action.superPackage.pax) : parseInt(state.pax),
					image: action.superPackage.image,
					nights: parseInt(action.superPackage.nights)
				}
				return updateStateObject(state, {superPackage: newSuperPackage, days: newDays, nights: parseInt(action.superPackage.nights) });
			}

		case 'REMOVE_SUPER_PACKAGE':
			return updateStateObject(state, {superPackage:false, nights: 0});

		case 'EDIT_SUPER_PACKAGE':
			if( state.superPackage ){
				let superPackage = state.superPackage;
				superPackage.pax = action.pax;

				changes = {
					superPackage: superPackage,
				}
			}
			return updateStateObject(state, changes, true);

		case 'UPDATE_FIELD':
			return updateStateObject(state, {[action.key]:action.value});
		case 'UPDATE_PAX':

			changes = {pax: action.value};

			if(state.hotel){
				let hotel = state.hotel;
				hotel.pax = action.value;
				changes.hotel = hotel;
			}
			if(state.activities.length > 0){
				let activities = [];
				state.activities.map( (item) => {
					let activity = {...item, pax: action.value}
					activities.push(activity);
				})
				changes.activities = activities;
			}

			return updateStateObject(state, changes);
		case 'ADD_PACKAGE':
			return updateStateObject(state, { package: action.package });
			
		case 'RESET_ACTIVITIES':
			return updateStateObject(state, { activities: [] });
		case 'RESET_HOTEL':
			return updateStateObject(state, { hotel: false });
		case 'RESET_ACTIVITIES_AND_HOTEL':
			return updateStateObject(state, { activities: [], hotel: false });
		case 'UPDATE_SURVEY':
			const survey = { ...state.survey, [action.key]: action.value, completed: true }
			return updateStateObject(state, { survey: survey });
		default:
			throw new Error('Where will this go?');

	}

}

export default function QuoteFormReducer( destination, loggedIn ) {
    const initialState = {
		days: 1,
		pax: destination.quoteData.pax || 12,
		nights: 0,
		date: destination.quoteData.date || "",
		requireHotel: true,
		hotel: false,
		hotelStandard: false,
		activities: [],
		package: false,
		superPackage: false,
		name: destination.quoteData.name || "",
		email: destination.quoteData.email || "",
		phone: destination.quoteData.phone || "",
		code: "",
		notes: "",
		consent: true,
		marketing: false,
		createAccount: loggedIn ? false : true,
		password: destination.quoteData.password || "",
		token: "",
		survey: {
			completed: false,
			role: 0,
			stage: 0
		}
		
    }
    return useReducer(reducer, initialState);
}
